var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "134",
        viewBox: "0 0 181 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M180.94 0H0V133.106H180.94V0Z", fill: "#FFC300" },
      }),
      _c("path", {
        attrs: {
          d: "M67 0H181V95C118.041 95 67 52.4654 67 0Z",
          fill: "#F9DF40",
        },
      }),
      _c("path", {
        attrs: {
          d: "M67 133L-5.42402e-06 133L-6.15773e-07 78C37.002 78 67 102.625 67 133Z",
          fill: "#F9DF40",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }